import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6111e67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "MensagensDeErro"
}
const _hoisted_2 = {
  key: 1,
  class: "MensagensDeErro"
}
const _hoisted_3 = { class: "Arquivos" }
const _hoisted_4 = {
  key: 0,
  class: "Arquivos__Aviso"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-exclamation-circle Arquivos__IconeAviso" }, null, -1))
const _hoisted_6 = { class: "Arquivos__TextoAviso" }
const _hoisted_7 = { class: "CardArquivo__InformacoesGerais" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-file-o CardArquivo__Icone" }, null, -1))
const _hoisted_9 = { class: "CardArquivo__Dados" }
const _hoisted_10 = { class: "CardArquivo__TamanhoEStatus" }
const _hoisted_11 = { class: "CarregadorDeArquivos__TextoEstadoVazio" }
const _hoisted_12 = { class: "CarregadorDeArquivos__TextoEstadoVazio" }
const _hoisted_13 = { class: "CarregadorDeArquivos__TextoEstadoVazio" }

import Button from "primevue/button"
  import FileUpload from "primevue/fileupload"
  import Badge from "primevue/badge"
  import { WritableComputedRef, computed, onBeforeMount, ref } from "vue"
  import {
    Escritor,
    EscritorErro,
    usarEscritorDeDados,
  } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import AMensagemDeErro from "@/components/Importacoes/AMensagemDeErro/AMensagemDeErro.vue"

  import ProgressBar from "primevue/progressbar"
  import { cancelamento } from "@/http/cancelar/cancelar.services"
  import {
    TiposDeStatus,
    usarImportacoesStore,
  } from "@/store/importacoes/importacoes.store"
  import { storeToRefs } from "pinia"
  import { usarBaixadorDeArquivos } from "@/composable/UsarBaixadorDeArquivos/usarBaixadorDeArquivos"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { useI18n } from "vue-i18n"

  interface Props {
    tamanhoMaximoEmBytes: number
    formatosAceitos: string[]
    escritorDeArquivos: Escritor<unknown, File>
    textoEstadoVazio: string
    idImportacao: string
  }

  type TipoDeSeveridade = "success" | "danger" | "warning" | "info"

  type EnumeracaoDeStatus = {
    [keyof: string]: {
      tipo: TipoDeSeveridade
      texto: string
      icone?: string
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MCarregadorDeArquivos',
  props: {
    tamanhoMaximoEmBytes: null,
    formatosAceitos: null,
    escritorDeArquivos: null,
    textoEstadoVazio: null,
    idImportacao: null
  },
  setup(__props: any) {

const props = __props as {
    tamanhoMaximoEmBytes: number
    formatosAceitos: string[]
    escritorDeArquivos: Escritor<unknown, File>
    textoEstadoVazio: string
    idImportacao: string
  }

  const { t } = useI18n()

  

  const { onErro, onSucesso, onAviso } = usarMensagemUsuario()
  const { executarDownloadDeArquivo } = usarBaixadorDeArquivos()
  const { resolver } = usarEscritorDeDados()
  const { formatarDataNoPadraoTimesheet, hoje } = usarDataHora()
  const {
    possuiArquivosSendoImportados,
    estaCarregando: estaCarregandoStore,
    arquivos: arquivosStore,
    estadoDoArquivo: estadoArquivoStore,
  } = storeToRefs(usarImportacoesStore())

  const arquivos = computed({
    get: () => {
      return arquivosStore.value[props.idImportacao]
    },
    set: (arquivo: Array<File>) => {
      arquivosStore.value[props.idImportacao] = arquivo
    },
  })

  const estadoArquivoIndice: WritableComputedRef<TiposDeStatus[]> = computed({
    get: () => {
      return estadoArquivoStore.value[props.idImportacao]
    },
    set: (status: TiposDeStatus[]) => {
      estadoArquivoStore.value[props.idImportacao] = status
    },
  })

  const estaCarregando = computed({
    get: () => {
      return estaCarregandoStore.value[props.idImportacao]
    },
    set: (status: boolean) => {
      estaCarregandoStore.value[props.idImportacao] = status
    },
  })

  const mensagemRetornoRequisicao = ref<string[]>([])

  const enumeracaoDeStatus: EnumeracaoDeStatus = {
    sucesso: {
      tipo: "success",
      texto: t("finalizado"),
    },
    erro: {
      tipo: "danger",
      texto: t("falhaAoImportar"),
    },
    aguardando: {
      tipo: "warning",
      texto: t("aguardando"),
    },
    importando: {
      icone: "pi pi-spin pi-spinner",
      tipo: "info",
      texto: t("importando"),
    },
  }

  const formatosDeArquivoAceitos = computed(() => {
    return props.formatosAceitos.join(",")
  })

  const porcentagemConcluida = computed((): number => {
    const quantidadeDeArquivos = arquivos.value.length

    if (quantidadeDeArquivos === 0) {
      return 0
    }

    const quantidadeDeArquivosImportados = estadoArquivoIndice.value.filter(
      (estado) => ["sucesso", "erro"].includes(estado)
    ).length

    return (quantidadeDeArquivosImportados / quantidadeDeArquivos) * 100
  })

  const existemArquivosAguardando = computed(() => {
    return estadoArquivoIndice.value.some((estado) => estado === "aguardando")
  })

  const lidarComSelecaoDeArquivos = (event): void => {
    if (arquivos.value.length !== 0) {
      const quantidadeDeNovosArquivos = Math.abs(
        arquivos.value.length - event.files.length
      )
      arquivos.value = [...event.files]

      for (let indice = 0; indice < quantidadeDeNovosArquivos; indice++) {
        estadoArquivoIndice.value.push("aguardando")
      }
    } else {
      arquivos.value = [...event.files]

      event.files.forEach(() => {
        estadoArquivoIndice.value.push("aguardando")
      })
    }
  }

  const removerItem = (removeFileCallback, indice): void => {
    arquivos.value.splice(indice, 1)
    estadoArquivoIndice.value.splice(indice, 1)
    removeFileCallback(indice)

    if (arquivos.value.length === 0) {
      limparMensagemDeRetornoDeErro()
    }
  }

  const converterBytesParaKB = (bytes: number): string => {
    const KILOBYTE = 1024
    const DECIMAIS = 2
    const UNIDADE = "KB"

    if (bytes === 0) {
      return `0 ${UNIDADE}`
    }

    const indice = Math.floor(Math.log(bytes) / Math.log(KILOBYTE))
    const tamanhoFormatado = parseFloat(
      (bytes / Math.pow(KILOBYTE, indice)).toFixed(DECIMAIS)
    )

    return `${tamanhoFormatado} ${UNIDADE}`
  }

  const enviarArquivos = async (): Promise<void> => {
    limparMensagemDeRetornoDeErro()
    const estadosPorIndice = estadoArquivoIndice.value
    estaCarregando.value = true

    for (let indice = 0; indice < estadosPorIndice.length; indice++) {
      if (estadosPorIndice[indice] !== "aguardando") {
        continue
      }

      const arquivo = arquivos.value[indice]
      await executarEscritorPorArquivo(arquivo, indice)
    }

    definirMensagemPorStatusDosArquivos()
    estaCarregando.value = false
  }

  const baixarArquivoResultado = (arquivo: Blob, nome: string): void => {
    executarDownloadDeArquivo({
      conteudo: arquivo,
      nome: `${nome}-resultado-${formatarDataNoPadraoTimesheet(hoje)}`,
      extensao: ".zip",
    })
  }

  const executarEscritorPorArquivo = async (
    arquivo: File,
    indiceDoArquivo: number
  ): Promise<void> => {
    cancelamento.ignorarRequisicao("/api/importacoes/**")

    mudarEstadoDoArquivoParaImportando(indiceDoArquivo)
    props.escritorDeArquivos.mudarArgumentos([arquivo])
    await props.escritorDeArquivos.executar()

    const lidarComSucessoDaImportacao = (dados: unknown): void => {
      baixarArquivoResultado(dados as Blob, arquivo.name.split(".")[0])
      mudarEstadoDoArquivoParaSucesso(indiceDoArquivo)
    }

    const lidarComErroDaImportacao = (resposta: EscritorErro): void => {
      mudarEstadoDoArquivoParaErro(indiceDoArquivo)
      adicionarMensagemDeRetornoDeErro(arquivo, resposta)
    }

    resolver(props.escritorDeArquivos.resultado, {
      sucesso: lidarComSucessoDaImportacao,
      erro: lidarComErroDaImportacao,
    })
  }

  const adicionarMensagemDeRetornoDeErro = (
    arquivo: File,
    resposta: EscritorErro
  ): void => {
    mensagemRetornoRequisicao.value.push(`${arquivo.name} ${resposta.mensagem}`)
  }

  const removerTodosArquivos = (callback: () => void): void => {
    callback()
    arquivos.value = []
    estadoArquivoIndice.value = []
    limparMensagemDeRetornoDeErro()
  }

  const selecionarArquivos = (callbackDeSelecionar: () => void): void => {
    limparMensagemDeRetornoDeErro()
    callbackDeSelecionar()
  }

  const definirMensagemPorStatusDosArquivos = (): void => {
    const todosOsArquivosForamImportadosComSucesso =
      estadoArquivoIndice.value.every((estado) => estado === "sucesso")

    const todosOsArquivosFalharamAoSeremImportados =
      estadoArquivoIndice.value.every((estado) => estado === "erro")

    if (todosOsArquivosForamImportadosComSucesso) {
      onSucesso({
        detalhes: t("todosOsArquivosForamImportadosComSucesso"),
        resumo: t("importacaoFinalizada"),
      })
    } else if (todosOsArquivosFalharamAoSeremImportados) {
      onErro({
        detalhes: t("todosOsArquivosFalharamAoSeremImportados"),
        resumo: t("importacaoFinalizada"),
      })
    } else {
      onAviso({
        detalhes: t("algunsArquivosFalharamAoSeremImportados"),
        resumo: t("importacaoFinalizada"),
      })
    }
  }

  const limparMensagemDeRetornoDeErro = (): void => {
    mensagemRetornoRequisicao.value = []
  }

  const iconeDoEmblema = (index: number): string | undefined => {
    return enumeracaoDeStatus[estadoArquivoIndice.value[index]].icone
  }

  const textoDoEmblema = (index: number): string => {
    return enumeracaoDeStatus[estadoArquivoIndice.value[index]].texto
  }

  const tipoDoEmblema = (index: number): TipoDeSeveridade => {
    return enumeracaoDeStatus[estadoArquivoIndice.value[index]].tipo
  }

  const mudarEstadoDoArquivoParaImportando = (indice: number): void => {
    estadoArquivoIndice.value.splice(indice, 1, "importando")
  }

  const mudarEstadoDoArquivoParaSucesso = (indice: number): void => {
    estadoArquivoIndice.value.splice(indice, 1, "sucesso")
  }

  const mudarEstadoDoArquivoParaErro = (indice: number): void => {
    estadoArquivoIndice.value.splice(indice, 1, "erro")
  }

  const iniciarDadosDaStorePorImportador = (): void => {
    if (!possuiArquivosSendoImportados.value(props.idImportacao)) {
      arquivosStore.value[props.idImportacao] = []
      estadoArquivoStore.value[props.idImportacao] = []
      estaCarregandoStore.value[props.idImportacao] = false
    }
  }

  onBeforeMount(() => {
    iniciarDadosDaStorePorImportador()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ProgressBar), {
      class: "BarraProgresso",
      value: _unref(porcentagemConcluida)
    }, null, 8, ["value"]),
    _createVNode(_unref(FileUpload), {
      onSelect: lidarComSelecaoDeArquivos,
      accept: _unref(formatosDeArquivoAceitos),
      class: "CarregadorDeArquivos",
      "custom-upload": "",
      "data-testid": "CarregadorDeArquivos",
      "invalid-file-size-message": `{0} ${_unref(t)('excedeTamanhoMaximoPermitido')}`,
      "invalid-file-type-message": `${_unref(t)('formatoDoArquivo')} {0} ${_unref(t)('invalidoArquivoDeveSerDoTipoXLSX')}`,
      "max-file-size": __props.tamanhoMaximoEmBytes,
      mode: "advanced",
      multiple: true
    }, _createSlots({
      header: _withCtx(({ files, chooseCallback, clearCallback }) => [
        _createVNode(_unref(Button), {
          onClick: ($event: any) => (selecionarArquivos(chooseCallback)),
          class: "CarregadorDeArquivos__Botoes",
          "data-testid": "CarregadorDeArquivos__BotaoSelecionarArquivo",
          disabled: _unref(estaCarregando),
          icon: "pi pi-plus",
          label: _unref(t)('selecionarArquivo')
        }, null, 8, ["onClick", "disabled", "label"]),
        (files.length !== 0)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              onClick: enviarArquivos,
              class: "CarregadorDeArquivos__Botoes",
              disabled: _unref(estaCarregando) || !_unref(existemArquivosAguardando),
              icon: "pi pi-upload",
              label: _unref(t)('importarTudo'),
              loading: _unref(estaCarregando)
            }, null, 8, ["disabled", "label", "loading"]))
          : _createCommentVNode("", true),
        (files.length !== 0)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 1,
              onClick: ($event: any) => (removerTodosArquivos(clearCallback)),
              class: "CarregadorDeArquivos__Botoes --Cancelar",
              "data-testid": "CarregadorDeArquivos__BotaoLimparLista",
              disabled: _unref(estaCarregando),
              icon: "pi pi-times",
              label: _unref(t)('limparLista')
            }, null, 8, ["onClick", "disabled", "label"]))
          : _createCommentVNode("", true)
      ]),
      content: _withCtx(({ removeFileCallback, messages }) => [
        (messages?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages, (mensagem, indice) => {
                return (_openBlock(), _createBlock(AMensagemDeErro, {
                  key: indice,
                  mensagem: mensagem
                }, null, 8, ["mensagem"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (mensagemRetornoRequisicao.value?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mensagemRetornoRequisicao.value, (mensagem, indice) => {
                return (_openBlock(), _createBlock(AMensagemDeErro, {
                  key: indice,
                  mensagem: mensagem
                }, null, 8, ["mensagem"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_unref(arquivos).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('aoImportarArquivoSeraFeitoDownload')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arquivos), (arquivo, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: arquivo.name + arquivo.type + arquivo.size,
              class: "CardAquivo",
              "data-testid": "CardArquivo"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(arquivo.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", null, _toDisplayString(converterBytesParaKB(arquivo.size)), 1),
                    _createVNode(_unref(Badge), {
                      class: "CardArquivo__Emblema",
                      severity: tipoDoEmblema(index)
                    }, {
                      default: _withCtx(() => [
                        (iconeDoEmblema(index))
                          ? (_openBlock(), _createElementBlock("em", {
                              key: 0,
                              class: _normalizeClass(iconeDoEmblema(index))
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(textoDoEmblema(index)), 1)
                      ]),
                      _: 2
                    }, 1032, ["severity"])
                  ])
                ])
              ]),
              (_unref(estadoArquivoIndice)[index] !== 'importando')
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    onClick: ($event: any) => (removerItem(removeFileCallback, index)),
                    class: "CardArquivo__RemoverItem",
                    "data-testid": "CardArquivo__BotaoRemoverItem",
                    icon: "pi pi-times"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 2
    }, [
      (_unref(arquivos).length === 0)
        ? {
            name: "empty",
            fn: _withCtx(() => [
              _createElementVNode("p", _hoisted_11, _toDisplayString(__props.textoEstadoVazio), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('formatoAceitoXLSX')), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('tamanhoMaximoDeArquivo')), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["accept", "invalid-file-size-message", "invalid-file-type-message", "max-file-size"])
  ], 64))
}
}

})